import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MedIconTriangleUpModule } from "@mk/med-icons";

import { MedGroupControlComponent } from "./med-group-control.component";
import { GroupItemDirective } from "./group-item.directive";

@NgModule({
  declarations: [
    MedGroupControlComponent,
    GroupItemDirective,
  ],
  imports: [
    CommonModule,
    MedIconTriangleUpModule,
  ],
  exports: [
    MedGroupControlComponent,
    GroupItemDirective,
  ],
})
export class MedGroupControlModule { }
